import { ResultOf } from "gql.tada";
import { AccessibleMediaFragment } from "@queries/fragments/AccessibleMediaFragment";
import AudioPlayer from "@components/entries/AudioPlayer";

export const AccessibleMedia = ({
  item,
  noCaption = false,
}: {
  item: ResultOf<typeof AccessibleMediaFragment>;
  noCaption?: boolean;
}) => {
  if (!item) return null;

  const mediaType = item?.media?.contentType?.split('/')[0];
  const classNames = "w-full select-none drag-none block object-contain mx-auto rounded-xl";

  const getMedia = () => {
    switch (mediaType) {
      case 'image':
        return (
          <img
            src={item?.media?.url as string}
            alt={item?.altText as string}
            className={classNames}
          />
        )

    case 'video':
      return (
        <video
          controls
          poster={item?.posterImage?.url as string}
          src={item?.media?.url as string}
          className={classNames}
        />
      )

    case 'audio':
      return (
        <AudioPlayer
          src={item?.media?.url as string}
          img={item?.posterImage?.url as string}
          title={item?.altText as string}
        />
      )

    // unknown media type might have an embedId
    default:
      if (item.embedId) {
        if (item.embedId.length === 11) {
          return (
            <iframe
              className={classNames}
              style={{ aspectRatio: `530/316`}}
              src={`https://www.youtube.com/embed/${item.embedId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          );
        }

        if (item.embedId.length === 22) {
          return (
            <iframe
              data-testid="embed-iframe"
              className={classNames}
              src={`https://open.spotify.com/embed/episode/${item.embedId}?utm_source=generator&theme=0`}
              width="100%"
              height="152"
              frameBorder="0"
              allowFullScreen
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            />
          );
        }
      }

      return <></>;
    }
  }

  return (
    <div className="accessible-media">
      {item?.title &&
        <h2 className="text-heading-3 mb-[40px] text-center">{item.title}</h2>
      }
      {getMedia()}
      {(item?.caption && !noCaption) &&
        <p className="font-bold my-[25px] opacity-50">{item.caption}</p>
      }
    </div>
  );
};
